import React from 'react';
import { Result } from '@nackle/origami';
import { getString } from '@nackle/intl-tools';

export default class ErrorBoundary extends React.Component {
    constructor( props ) {
        super( props );
        this.state = { hasError: false };
    }

    static getDerivedStateFromError( error ) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }


    render() {
        if ( this.state.hasError ) {
            return <Result title={ getString( 'recognition.error.generic' ) } status="500" type="image" />;
        }

        return this.props.children;
    }
}
